import { ErrorHandler, Provider } from '@angular/core';
import { GlobalErrorHandler } from '../services/error-handler/gloabl-error-handler.service';

export const GlobalErrorHandlerProvider: Provider = {
  provide: ErrorHandler,
  useClass: GlobalErrorHandler,
};
